import { createApp } from 'vue'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router/main.js'
import VueSignaturePad from 'vue-signature-pad'

// Vuetify
import './styles/style.scss'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import './registerServiceWorker'

const vuetify = createVuetify({
	icons: {
		defaultSet: 'mdi',
		aliases,
		sets: {
			mdi,
		}
	},
})

const pinia = createPinia()
const app = createApp(App)

app.use(VueSignaturePad)
app.use(pinia)
app.use(vuetify)
app.use(router)
app.mount('#app')